var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      !_vm.srOnlyTitle
        ? _c("plain-text-control", {
            attrs: { title: _vm.titleKey, required: _vm.$attrs.required }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "table tablerow",
          attrs: {
            id: _vm.id,
            "aria-label": _vm.titleKey
              ? _vm.$t(_vm.titleKey)
              : _vm.$t(_vm.tableKey)
          }
        },
        [
          _c("thead", [
            _c(
              "tr",
              [
                _c(
                  "th",
                  {
                    staticClass: "w-40",
                    attrs: { id: _vm.id + "_" + _vm.tableKey }
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.$t(_vm.tableKey)))]),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v(
                        " " + _vm._s(_vm.tableKey ? "" : _vm.$t(_vm.titleKey))
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.years, function(year) {
                  return _c(
                    "th",
                    {
                      key: _vm.id + "-" + year,
                      staticClass: "right",
                      attrs: { id: _vm.id + "_" + year }
                    },
                    [_c("span", [_vm._v(_vm._s(year))])]
                  )
                }),
                _vm._v(" "),
                _vm.showRowTotals
                  ? _c(
                      "th",
                      {
                        staticClass: "right",
                        attrs: { id: _vm.id + "_total" }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("toUpperCase")(_vm.$t("Total"))))
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showActions
                  ? _c(
                      "th",
                      {
                        staticClass: "w-5",
                        attrs: { id: _vm.id + "_actions" }
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v(_vm._s(_vm.$t("Sr_Actions")))
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.value.items, function(estimate, index) {
              return _c(
                "tr",
                {
                  key: _vm.id + "-" + index,
                  staticClass: "paddingless",
                  attrs: { id: _vm.id + "-" + index }
                },
                [
                  !estimate.canDelete
                    ? _c(
                        "th",
                        { staticClass: "w-40 row-heading" },
                        [
                          _c("plain-text-control", {
                            attrs: { title: estimate.name, noMargin: true }
                          })
                        ],
                        1
                      )
                    : _vm.showOptionSelector
                    ? _c("single-select-table-cell", {
                        attrs: {
                          classes: ["input-cell", "row-heading"],
                          value: estimate.type ? estimate.type : null,
                          options: _vm.options,
                          required: true,
                          disabled: _vm.$attrs.disabled || estimate.isReadOnly,
                          dropdownId: "estimateoption_" + index,
                          title: _vm.tableKey,
                          srLabel: true,
                          doNotUseResources: true,
                          nullable: false
                        },
                        on: {
                          input: function($event) {
                            return _vm.setEstimateTypeAndName(estimate, $event)
                          }
                        }
                      })
                    : _c(
                        "td",
                        { staticClass: "w-40 input-cell row-heading" },
                        [
                          _c("text-area-control", {
                            attrs: {
                              rows: 1,
                              maxLength: 50,
                              required: true,
                              disabled:
                                _vm.$attrs.disabled || estimate.isReadOnly,
                              placeholderKey: _vm.textAreaPlaceholderKey,
                              id: _vm.id + "-" + (index + 1),
                              labelledBy: _vm.id + "_" + _vm.tableKey
                            },
                            model: {
                              value: estimate.name,
                              callback: function($$v) {
                                _vm.$set(estimate, "name", $$v)
                              },
                              expression: "estimate.name"
                            }
                          })
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _vm._l(estimate.yearlyItems, function(yearItem) {
                    return _c(
                      "td",
                      {
                        key: _vm.id + "-" + yearItem.year + "-" + index,
                        staticClass: "input-cell"
                      },
                      [
                        _c("numeric-input-control", {
                          attrs: {
                            required: yearItem.isRequired,
                            disabled:
                              _vm.$attrs.disabled ||
                              estimate.isReadOnly ||
                              yearItem.isReadOnly,
                            placeholderKey: _vm.numberInputPlaceholderKey,
                            rules: _vm.numericRules(
                              estimate.type,
                              yearItem.year
                            ),
                            labelledBy: _vm.id + "_" + yearItem.year
                          },
                          model: {
                            value: yearItem.value,
                            callback: function($$v) {
                              _vm.$set(yearItem, "value", $$v)
                            },
                            expression: "yearItem.value"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.showRowTotals
                    ? _c("td", { staticClass: "right disabled-background" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatNumber")(
                                estimate.ignoreForCalculation
                                  ? null
                                  : _vm.value.computeEstimateTotal(estimate)
                              )
                            ) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showActions
                    ? _c(
                        "td",
                        {
                          class: [
                            "w-5",
                            _vm.isDisabled ? "disabled-background" : ""
                          ]
                        },
                        [
                          _c("span", { staticClass: "centered" }, [
                            _vm.canDelete(estimate) && !_vm.isReadOnly
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-link btn-contrast",
                                    attrs: {
                                      type: "button",
                                      "aria-label":
                                        _vm.$t("Btn_DeleteRow") +
                                        (index + 2) +
                                        " -. " +
                                        _vm.$t("Accessibility.ConfirmDeleteRow")
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.remove(estimate)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fas fa-trash-alt fa-lg centered"
                                    })
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                2
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.showColumnTotals
            ? _c("tfoot", [
                _c(
                  "tr",
                  [
                    _c("td", { staticClass: "w-40 disabled-background" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("toUpperCase")(_vm.totalRowHeader))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.years, function(year, index) {
                      return _c(
                        "td",
                        {
                          key: _vm.id + "-total-" + index,
                          staticClass: "right disabled-background"
                        },
                        [
                          _c("span", [
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v(
                                _vm._s(year) +
                                  " " +
                                  _vm._s(_vm.$t("Total")) +
                                  " "
                              )
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("formatNumber")(
                                    _vm.value.computeYearlyTotal(year)
                                  )
                                )
                            )
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.showRowTotals
                      ? _c("td", { staticClass: "right disabled-background" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatNumber")(_vm.value.grandTotal)
                              )
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showActions
                      ? _c("td", { staticClass: "w-5 disabled-background" })
                      : _vm._e()
                  ],
                  2
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      !_vm.isReadOnly
        ? _c("div", { staticClass: "mt-3" }, [
            _vm.showActions && _vm.enableAddButton
              ? _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.top.center",
                        value: _vm.getAddButtonTooltip(),
                        expression: "getAddButtonTooltip()",
                        modifiers: { top: true, center: true }
                      }
                    ],
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.addEstimate()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t(_vm.$attrs.addButtonKey)) +
                        "\n      "
                    ),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v(_vm._s(_vm.$t(_vm.$attrs.addButtonTooltip)))
                    ])
                  ]
                )
              : _vm.showActions
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: {
                      type: "button",
                      disabled: "",
                      "aria-disabled": "true"
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t(_vm.$attrs.addButtonKey)) +
                        "\n    "
                    )
                  ]
                )
              : _vm._e()
          ])
        : _c("div", { staticClass: "mb-5" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }